import { getTenTimesLighterColor } from './StyleUtils';

export class StyleRouteGenerator {
    static getDrawStyle(mainColor: string = '#9daecc'): {
        strokeWeight: string;
        strokeColor: string;
        strokeOpacity: string;
        fillOpacity: string;
        strokeDasharray?: string;
    }[] {
        return [
            {
                strokeWeight: '4px',
                strokeColor: mainColor,
                strokeOpacity: '0.9',
                fillOpacity: '0.9',
            },
            {
                strokeWeight: '2px',
                strokeColor: getTenTimesLighterColor(mainColor, 4),
                strokeOpacity: '0.9',
                fillOpacity: '0.9',
            },
        ];
        return [
            // {
            //     strokeWeight: '6px',
            //     strokeColor: '#333333',
            //     strokeOpacity: '0.8',
            //     fillOpacity: '0.8',
            // },
            {
                strokeWeight: '5px',
                strokeColor: '#ffffff',
                strokeOpacity: '0.9',
                fillOpacity: '0.9',
                // strokeDasharray: '4, 9',
            },
            {
                strokeWeight: '3px',
                strokeColor: mainColor,
                strokeOpacity: '0.9',
                fillOpacity: '0.9',
                strokeDasharray: '4, 9',
            },
        ];
    }

    static getPointsFormatted(points: { x: number; y: number }[]): string {
        if (points.length < 2) {
            throw new Error('At least two points are required to create a route');
        }
        let routeLine = [];
        for (let i in points) {
            routeLine.push(points[i].x + ',' + points[i].y);
        }
        return routeLine.join(' ');
    }

    static getStyle(color: string = '#222222'): any {
        return {
            drawStyle: this.getDrawStyle(color),
            closed: false,
        };
    }
}
